
import React, { useMemo } from 'react';
import {
	InstitutionsWrapper,
	Page,
	PickerHOC,
	TargetsWrapper,
	TargetTypesWrapper,
	UserWrapper,
} from '@coinscrap/webapp-core';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';

import { SimulationDataBase } from './SimulationDataBase';

export const SimulationData = PickerHOC(
	{
		targetType: {
			arrayItemMatcher: {
				itemPropertyPath: 'identifier',
				type: 'value',
				value: 'ALLIANZ_VIDA_RIESGO',
			},
			sourcePath: 'targetTypes',
			sourceWrapper: TargetTypesWrapper,
		},
		target: {
			sourceWrapper: TargetsWrapper,
			sourcePath: 'targets',
			arrayItemMatcher: {
				type: 'param',
				paramName: 'targetId',
				itemPropertyPath: 'id',
			},
		},
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
		institution: {
			arrayItemMatcher: {
				itemPropertyPath: 'identifier',
				type: 'value',
				value: 'allianz',
			},
			sourcePath: 'institutions',
			sourceWrapper: InstitutionsWrapper,
		},
	},
	LoadingScreen,
)(() => {
	let { query } = Page.use();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const internalStep = useMemo(() => query?.internalStep && parseInt(query?.internalStep), [
		query,
	]);

	const { targetType, target, user, institution } = PickerHOC.use();
	return (
		<SimulationDataBase
			internalStep={internalStep}
			targetType={targetType}
			target={target}
			user={user}
			institution={institution}
			isB2B={false}
		/>
	);
});
